import React, { useState } from 'react';

import { Typography, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import cx from 'classnames';

import ChevronTopIcon from '../../../../assets/icons/ChevronTopIcon';
import { colorsPalette } from '../../../../theme';
import useStyles from './style';

interface FilterWrapperProps {
  title: string;
  children: React.ReactNode;
  wrapperClass?: string;
  withoutToggle?: boolean;
}

const FilterWrapper: React.FC<FilterWrapperProps> = ({
  title,
  children,
  wrapperClass = '',
  withoutToggle = false,
}) => {
  const [filterOpened, setFilterOpened] = useState(true);
  const classes = useStyles(filterOpened)();

  const toggleFilter = () => {
    !withoutToggle && setFilterOpened((prevState) => !prevState);
  };

  return (
    <Accordion
      expanded={filterOpened}
      onChange={toggleFilter}
      classes={{
        root: cx(classes.wrapper, wrapperClass),
        expanded: classes.wrapper,
        disabled: classes.wrapperDisabled,
      }}
      disabled={withoutToggle}
    >
      <AccordionSummary
        classes={{
          root: classes.headingRoot,
          content: classes.headingContent,
          expanded: classes.headingExpanded,
          disabled: classes.headingDisabled,
        }}
      >
        <Typography className={classes.title}>{title}</Typography>
        {!withoutToggle && <ChevronTopIcon className={classes.icon} color={colorsPalette.white} />}
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: classes.contentRoot,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterWrapper;
